// ============================================================
// 🔌 portalApi — couche de requêtes du Portail Client (Phase 18)
// Auth par COOKIE de session httpOnly => credentials: "include".
// Aucun token en localStorage, aucun header Bearer (≠ auth admin).
// ============================================================
import { getBackendUrl } from "../config";

/**
 * Appel JSON vers /api/portal/*. Renvoie { ok, status, data }.
 * Ne throw jamais sur un statut HTTP (l'appelant gère ok/status).
 */
export async function portalApi(path, { method = "GET", body } = {}) {
  let res;
  try {
    res = await fetch(`${getBackendUrl()}${path}`, {
      method,
      credentials: "include", // indispensable : envoie/réceptionne le cookie de session
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (networkErr) {
    return { ok: false, status: 0, data: { error: "Network error", code: "NETWORK" } };
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    /* réponse sans corps JSON */
  }
  return { ok: res.ok, status: res.status, data };
}
